import { getTeam } from "@/utils";

interface TeamLogoProps {
  teamId: string;
  size?: "sm" | "md" | "lg";
}

const sizeMap = {
  sm: "w-8 h-8 text-xs",
  md: "w-12 h-12 text-sm",
  lg: "w-16 h-16 text-lg",
};

export default function TeamLogo({ teamId, size = "md" }: TeamLogoProps) {
  const team = getTeam(teamId);
  return (
    <div
      className={`${sizeMap[size]} rounded-full flex items-center justify-center font-label font-bold text-white shrink-0 ring-2 ring-background-200`}
      style={{ backgroundColor: team.color }}
      title={team.name}
    >
      {team.abbr}
    </div>
  );
}